export default "__VITE_ASSET__tOROxZPq__"